import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { formatAddressToSingleLineSimple } from '@/utils/address'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsItineraryItemAddress',
  props: {
    city: null,
    state: null,
    street1: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  city?: string
  state?: string
  street1?: string
  title?: string
};



const address = computed(() => {
  return formatAddressToSingleLineSimple(props.street1, props.city, props.state)
})

return { __sfc: true,props, address }
}

})